export default () => (
  <svg
    width="10"
    height="10"
    viewBox="0 0 10 10"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.95898 0.711914C8.30514 0.429311 8.80504 0.429631 9.15137 0.711914L9.22363 0.776367L9.28809 0.848633C9.59052 1.21955 9.56927 1.76656 9.22363 2.1123L6.33594 5L9.22363 7.8877C9.59235 8.25653 9.59243 8.85484 9.22363 9.22363C8.85483 9.59223 8.25647 9.59229 7.8877 9.22363L5 6.33594L2.1123 9.22363C1.74345 9.59215 1.14509 9.59236 0.776367 9.22363C0.407742 8.8549 0.40788 8.25652 0.776367 7.8877L3.66406 5L0.776367 2.1123C0.407814 1.74353 0.407808 1.14514 0.776367 0.776367L0.848633 0.711914C1.19492 0.429559 1.69482 0.429383 2.04102 0.711914L2.1123 0.776367L5 3.66406L7.8877 0.776367L7.95898 0.711914Z"
      fill="currentColor"
    />
  </svg>
);
